export const inspectTable = [
  {
    title: '1. 산업안전보건 자율점검 관리(주1회 작성, 월1회 보고)',
    content: `시설관리, 청소, 급식(조리), 통학차량보조 분야 점검표 작성`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '2. 산업안전보건법령의 요지 게시 및 안전보건 표지 부착(스티커북 등 활용)',
    content: `산업안전보건 법령의 요지 부착`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '2. 산업안전보건법령의 요지 게시 및 안전보건 표지 부착(스티커북 등 활용)',
    content: `안전보건관리규정의 게시`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '2. 산업안전보건법령의 요지 게시 및 안전보건 표지 부착(스티커북 등 활용)',
    content: `위험하거나 유해한 장소, 설비, 물질에 대한 안전보건표지 부착`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '2. 산업안전보건법령의 요지 게시 및 안전보건 표지 부착(스티커북 등 활용)',
    content: `5kg 이상 중량물을 인력으로 취급하는 장소에 표지 부착`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '3. 보호구 지급·착용 여부',
    content: `현장에 보호구(안전모, 안전화 등) 비치 및 관리상태`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '3. 보호구 지급·착용 여부',
    content: `보호구 지급대장 작성`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '4. 도급, 용역, 위탁 시 안전보건 조치(중대재해 발생 대응 매뉴얼)',
    content: `공사(용역) 안전·보건 체크리스트 작성`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '4. 도급, 용역, 위탁 시 안전보건 조치(중대재해 발생 대응 매뉴얼)',
    content: `용역업체와 협의체 구성 및 운영(월1회)`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '4. 도급, 용역, 위탁 시 안전보건 조치(중대재해 발생 대응 매뉴얼)',
    content: `용역업체와 활동점검(분기1회) 및 순회점검(주1회) 실시`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '5. 안전보건교육 실시',
    content: `관리감독자 교육(연간 16시간) 이수`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [1, 4],
    customIndex: [0, 1],
  },
  {
    title: '5. 안전보건교육 실시',
    content: `근로자 정기교육(반기 12시간) 이수`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [2, 5],
    customIndex: [0, 1],
  },
  {
    title: '5. 안전보건교육 실시',
    content: `채용시교육(상용직 8시간, 일용직 1시간) 이수`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [2, 5],
    customIndex: [0, 1],
  },

  {
    title: '6. 일반건강검진 실시(※건강보험공단에 자료요청)',
    content: `작년 일반검진 실시여부(모든 교직원 대상)`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [6, 5],
    customIndex: [0, 1],
  },
  {
    title: '6. 일반건강검진 실시(※건강보험공단에 자료요청)',
    content: `올해 건강검진 대상자 수검 독려 사실`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '7. 산업재해 발생 시 기록보존 서류',
    content: `산업재해조사표 작성 및 보고(1개월 이내)`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '7. 산업재해 발생 시 기록보존 서류',
    content: `재발방지계획 수립`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '7. 산업재해 발생 시 기록보존 서류',
    content: `수시 위험성평가(수시 근골격계부담작업 유해요인조사) 실시`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '8. 위험성평가 실시',
    content: `정기 위험성평가 실시 및 개선 이행(1년 주기)`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [7, 4],
    customIndex: [0, 1],
  },
  {
    title: '8. 위험성평가 실시',
    content: `위험성평가 절차서(규정) 작성`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '8. 위험성평가 실시',
    content: `근로자참여 기록(회의사진 등)`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '8. 위험성평가 실시',
    content: `위험성감소 대책 실시 기록(개선전후 사진 등)`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '9. 근골격계부담작업 유해요인조사 실시',
    content: `정기조사 실시 및 개선 이행(3년 주기)`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [7, 4],
    customIndex: [0, 1],
  },
  {
    title: '9. 근골격계부담작업 유해요인조사 실시',
    content: `정기조사 결과에 대한 근로자 교육 실시`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '10. 물질안전보건자료(MSDS) 관리 상태',
    content: `물질안전보건자료(MSDS) 비치`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '10. 물질안전보건자료(MSDS) 관리 상태',
    content: `취급 근로자에 대한 MSDS교육 실시`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '10. 물질안전보건자료(MSDS) 관리 상태',
    content: `덜어서 사용하는 용기에 경고표지 부착`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },

  {
    title: '11. 현업업무 시 안전 상태',
    content: `높은 곳 작업(추락 위험) 시 안전조치`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '11. 현업업무 시 안전 상태',
    content: `기계기구 또는 설비의 안전점검 및 이상유무`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '11. 현업업무 시 안전 상태',
    content: `넘어짐 사고 예방을 위한 정리정돈 및 통로확보`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '11. 현업업무 시 안전 상태',
    content: `감전 사고 위험 대비`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '11. 현업업무 시 안전 상태',
    content: `위험작업 관리대장 작성`,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
  {
    title: '12. 기타 안전·보건에 관한 사항',
    content: ``,
    content_input: true,
    notContentBefore: true,
    isChecked: ``,
    rowType: 'customType',
    customTypes: [4],
    customIndex: 1,
  },
];
